import axios from "../shared/axios";
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";

export function createContractOtherPrice(data) {
  return new Promise((resolve, reject) => {
    axios.post(`/api/ContractOtherPrice/Create`, data)
      .then(result => {
        store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_CONTRACT });
        resolve(result);
      })
      .catch(error => reject(error));
  });
}

export function updateContractOtherPrice(data) {
  return new Promise((resolve, reject) => {
    axios.put(`/api/ContractOtherPrice/Update`, data)
      .then(result => {
        store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_CONTRACT });
        resolve(result);
      })
      .catch(error => reject(error));
  });
}

export function getContractOtherPrices(contractid) {
  return axios.get(
    `/api/ContractOtherPrice/LoadContractOtherPriceList?contractid=${contractid}`
  );
}

export function getContractOtherPrice(contractotherpriceid) {
  return axios.get(
    `/api/ContractOtherPrice/GetContractOtherPrice?contractotherpriceid=${contractotherpriceid}`
  );
}

export function getContractOtherPriceChangeSummary(contractid, currencycode) {
  return axios.get(`/api/ContractOtherPrice/GetContractOtherPriceChangeSummary`, { params: { contractid, currencycode } });
}

export function getToSelectList(contractid, taskorderid, projectorderid) {
    taskorderid = taskorderid || 0;
    projectorderid = projectorderid || 0;
    return axios.get(`/api/ContractOtherPrice/ToSelectList`, { params: { contractid, taskorderid: taskorderid, projectorderid: projectorderid } });
}

export function deleteItem(contractotherpriceid) {
  return axios.delete(`/api/ContractOtherPrice/Delete`, { params: { contractotherpriceid } });
}

export function fetchSecondaryPriceChanges(contractotherpriceid) {
  return axios.get(`/api/ContractOtherPriceChange/LoadChanges`, { params: { contractotherpriceid } });
}

export function regenerateContractPriceChanges(contractid) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.patch(`/api/ContractOtherPrice/RegenerateContractPriceChanges`, null, { params: { contractid } });
            // store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}